import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";

/** Compact language toggle (EN / हिन्दी / ગુજરાતી) shown in the navbar. */
const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <div className="flex items-center rounded-full border border-white/15 bg-white/5 p-0.5 text-xs font-semibold">
      {SUPPORTED_LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={i18n.resolvedLanguage === code}
          className={`px-2.5 py-1.5 rounded-full transition-colors ${
            i18n.resolvedLanguage === code
              ? "bg-gradient-to-r from-brand-600 to-brand-400 text-navy-950"
              : "text-navy-200 hover:text-white"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
